<template>
  <section id="collection" class="catalog">
    <div class="catalog__heading">
      <div>
        <p class="section-label">The fragrance wardrobe</p>
        <h2>Find your signature</h2>
      </div>
      <p>{{ filteredProducts.length }} scents · perfume and ittar</p>
    </div>

    <div class="catalog__tools">
      <label class="search">
        <v-icon size="20">mdi-magnify</v-icon>
        <input v-model.trim="query" type="search" placeholder="Search by name, inspiration or notes">
        <button v-if="query" type="button" aria-label="Clear search" @click="query = ''">×</button>
      </label>
      <div class="filter-pills" aria-label="Product filters">
        <button
          v-for="filter in filters"
          :key="filter.id"
          type="button"
          :class="{ active: activeFilter === filter.id }"
          @click="activeFilter = filter.id"
        >
          {{ filter.label }}
        </button>
      </div>
    </div>

    <div v-if="filteredProducts.length" class="product-grid">
      <ProductCard
        v-for="(product, index) in visibleProducts"
        :key="product.id"
        :product="product"
        :number="String(index + 1).padStart(2, '0')"
        :tone="index % 4"
        @add-to-cart="$emit('add-to-cart', $event)"
      />
    </div>
    <div v-else class="empty-results">
      <v-icon size="38">mdi-scent</v-icon>
      <h3>No scent found</h3>
      <p>Try a different name or note.</p>
    </div>

    <button
      v-if="visibleProducts.length < filteredProducts.length"
      class="load-more"
      type="button"
      @click="visibleCount += 12"
    >
      Show more scents
    </button>
  </section>
</template>

<script>
import ProductCard from './ProductCard.vue'
import { fragranceVariants, getVariantPrice } from '../data/products'

export default {
  name: 'AllProducts',
  components: { ProductCard },
  props: {
    items: { type: Array, required: true }
  },
  data: () => ({
    query: '',
    activeFilter: 'all',
    visibleCount: 12,
    filters: [
      { id: 'all', label: 'All scents' },
      { id: 'new', label: 'New arrivals' },
      { id: 'under-120', label: 'Under ₹120' },
      { id: 'oud', label: 'Oud & woods' }
    ]
  }),
  computed: {
    filteredProducts() {
      const query = this.query.toLowerCase()
      return this.items.filter(product => {
        const searchable = `${product.name} ${product.inspiredBy} ${product.notes}`.toLowerCase()
        if (query && !searchable.includes(query)) return false
        if (this.activeFilter === 'new') return product.isNew
        if (this.activeFilter === 'under-120') return getVariantPrice(product, fragranceVariants.perfume10) < 120
        if (this.activeFilter === 'oud') return /oud|wood|cedar|leather|sandal/i.test(product.notes)
        return true
      })
    },
    visibleProducts() {
      return this.filteredProducts.slice(0, this.visibleCount)
    }
  },
  watch: {
    query() { this.visibleCount = 12 },
    activeFilter() { this.visibleCount = 12 }
  }
}
</script>

<style scoped>
.catalog { max-width: 1240px; margin: 0 auto; padding: 92px 28px; }
.catalog__heading { display: flex; align-items: end; justify-content: space-between; gap: 24px; }
.catalog__heading h2 { margin: 5px 0 0; color: #201d19; font-family: Georgia, serif; font-size: clamp(38px, 5vw, 66px); font-weight: 400; line-height: 1; }
.catalog__heading > p { color: #857b70; font-size: 13px; }
.section-label { margin: 0; color: #a16540; font-size: 11px; font-weight: 800; letter-spacing: 2px; text-transform: uppercase; }
.catalog__tools { display: flex; align-items: center; justify-content: space-between; gap: 18px; margin: 35px 0 28px; }
.search { width: min(430px, 100%); height: 48px; display: flex; align-items: center; gap: 10px; padding: 0 15px; border: 1px solid #ddd6cc; border-radius: 14px; background: #fff; }
.search input { width: 100%; border: 0; outline: 0; color: #29251f; font-size: 13px; }
.search button { border: 0; background: transparent; color: #897e71; font-size: 22px; }
.filter-pills { display: flex; gap: 7px; overflow-x: auto; }
.filter-pills button { flex: 0 0 auto; padding: 10px 14px; border: 1px solid #ddd6cc; border-radius: 30px; color: #6d645b; background: transparent; font-size: 12px; }
.filter-pills button.active { border-color: #26221d; color: #fff; background: #26221d; }
.product-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.empty-results { padding: 80px 20px; text-align: center; color: #847a6f; }
.empty-results h3 { margin: 12px 0 4px; color: #28241f; font-family: Georgia, serif; font-size: 25px; }
.load-more { display: block; margin: 36px auto 0; padding: 13px 22px; border: 1px solid #332f29; border-radius: 12px; background: transparent; color: #332f29; font-weight: 700; }
@media (max-width: 900px) {
  .product-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .catalog__tools { align-items: stretch; flex-direction: column; }
}
@media (max-width: 600px) {
  .catalog { padding: 65px 16px; }
  .catalog__heading { align-items: start; flex-direction: column; }
  .product-grid { grid-template-columns: 1fr; }
}
</style>